<template>
	<section class="select-section">
		<el-dialog :visible.sync="dialogVisible" width="70%" center
			style='min-width: 700px;' @close='close'>
			<p slot="title">{{title}}</p>
			<div class="search-row">
				<!-- 选择源类型 -->				
				<el-select v-if="selfType!=-1" class='search-select'
				 v-model="selfType" disabled slot="prepend" placeholder="请选择" size='small' ref='test'>
					<el-option v-for='item in select.type' :key='item.val'
					 :value="item.val" :label="item.name"></el-option>
				</el-select>
				<el-select v-else class='search-select' v-model="selectVal.type" slot="prepend" placeholder="请选择" size='small' ref='test'>
					<el-option v-for='item in select.type' :key='item.val'
					 :value="item.val" :label="item.name"></el-option>
				</el-select>
				<!-- 上下架 -->
				<el-select class='search-select'
				 v-model="selectVal.offline" slot="prepend"
				 placeholder="请选择" size='small'
				 :disabled="selfOffline!=-1">
					<el-option v-for='item in select.offline' :key='item.val'
					 :value="item.val" :label="item.name"></el-option>
				</el-select>
				<!-- 添加时间 -->
				<datetime-range ref='datetimeAdd'
				 :defaultPlaceholder='addPlaceholder'>
				</datetime-range>
				<!-- 开课时间 -->
				<datetime-range ref='datetimeOpen'
				 :defaultPlaceholder='openPlaceholder'>
				</datetime-range>
				<!-- 主讲老师 -->
				<el-input placeholder="请输入内容" v-model="selectVal.searchVal" class="input-with-select" @keyup.enter='getData' size='small' clearable>
					<el-select class='search-select' v-model="selectVal.searchKey" slot="prepend" placeholder="请选择">
						<el-option v-for='item in select.searchKey' :key='item.val'
					 :value="item.val" :label="item.name"></el-option>
					</el-select>
				</el-input>
				<el-button type="primary" size='small'
				 @click='currentPage=1;getData()'>搜索</el-button>
			</div>
			<el-table :data="tableData" class="table_list" 
			 style="width: 100%" border max-height="500"
			  @row-click='rowClickHandle' highlight-current-row>
				<!--<el-table-column label="选择" min-width="10%"
				type="selection">
				</el-table-column> -->
				<el-table-column label="选择" min-width="5%">
					<template slot-scope="scope">
                      	<div class="virtualBox"></div>
						<el-checkbox :value="choiceCourse.map(item=>item.id)" :label="scope.row.id">
							{{ }}
						</el-checkbox>
					</template>
				</el-table-column>
				<el-table-column prop="title" label="课程源名称" min-width="20%">
				</el-table-column>
				<el-table-column label="转码状态" min-width="10%">
					<template slot-scope="scope">
						<span v-if="scope.row.type === 2">
							<el-tag v-if="scope.row.state === 1">转码中</el-tag>
							<el-tag type="success" v-else-if="scope.row.state === 2">转码成功</el-tag>
							<el-tag type="danger" v-else-if="scope.row.state === 3">转码失败</el-tag>
						</span>
						<el-tag type="info" v-else>非视频</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="类型" min-width="10%">
					<template slot-scope="scope">
						<span>{{scope.row.type | typeFilter}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="teacherName" label="主讲老师" min-width="10%">
					<template slot-scope="scope">
						{{scope.row.teacherName?scope.row.teacherName:'-'}}
					</template>
				</el-table-column>
				<el-table-column prop="managerName" label="助手" min-width="10%">
					<template slot-scope="scope">
						{{scope.row.managerName?scope.row.managerName:'-'}}
					</template>
				</el-table-column>
				<el-table-column prop="knowledgeText" label="关联病种" min-width="10%">
					<template slot-scope="scope">
						{{scope.row.knowledgeText?scope.row.knowledgeText:'-'}}
					</template>
				</el-table-column>
				<el-table-column label="开课时间" min-width="20%">
					<template slot-scope="scope">
						<div>{{scope.row.planStartTime?scope.row.planStartTime:'-'}}</div>
						<div>{{scope.row.planEndTime}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="添加时间" min-width="20%">
					<template slot-scope="scope">
						{{scope.row.createTime?scope.row.createTime:'-'}}
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-wrap">
				<span>已选择{{ choiceCourse.length }}个课程源</span>
				<el-pagination class='el-pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
				</el-pagination>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitHandle">确 定</el-button>
			</span>
		</el-dialog>
	</section>
</template>

<script scoped>
import selectReq from "@/api/selectSource"
import datetimeRange from '@/components/datetimeRange'
export default {
	name: "selectCourseOrgin",
	data() {
	  return {
		addPlaceholder: {
		  start: '选择添加日期',
		  end: '选择添加日期'
		},
		openPlaceholder: {
		  start: '选择开课日期',
		  end: '选择开课日期'
		},
		title: "",
		choiceCourse: [],
		dialogVisible: false,
		pageSize: 20,
		currentPage: 1,
		totalCount: 0,
		tableData: [],
		select: {
		  type: [{
			  val: 0,
			  name: '全部源类型'
		  },{
			  val: 1,
			  name: '直播'
		  },{
			  val: 2,
			  name: '视频'
		  },{
			  val: 3,
			  name: '线下'
		  },{
			  val: 4,
			  name: '直播转视频'
		  },{
			  val: 5,
			  name: '课件'
		  },{
			  val: 6,
			  name: '网页'
		  },{
			  val: 8,
			  name: '音频'
		  }],
		  searchKey: [
          {
            val: 1,
            name: "课程源名称"
          },{
			  val: 2,
			  name: '主讲老师'
		  },{
			  val: 3,
			  name: '小助手'
		  }],
		  offline: [
          {
            val: -1,
            name: "全部状态"
          },{
			  val: 0,
			  name: '上架'
		  },{
			  val: 1,
			  name: '下架'
		  }]
		},
		selectVal: {
		  type: 0,
		  offline: -1,
		  searchKey: 1,
		  searchVal: ''
		}
	  };
	},
	props: {
		userType: {
			type: Number, //0，全部，1，孕妈，2，医生
			default: () => true
		},
		isSingle: {
			type: Boolean,
			default: () => false
		},
		selfType: {
			default: () => -1
		},
		selfOffline: {
			type: Number,
			default: () => -1
		}
	},
	components: {
		datetimeRange
	},
	mounted() {
		this.selectVal.offline = isNaN(this.selfOffline) ? -1 : this.selfOffline
	},
	methods: {
		open(title) {
		  this.dialogVisible = true;
		  this.title = title;
		  if(!this.tableData.length){
			  this.getData()
		  }
		},
		close() {
		  this.choiceCourse = []
		},
		submitHandle() {
			this.$emit('select-submit', this.choiceCourse)
			this.dialogVisible = false;
		},
		rowClickHandle(row) {
			let data = JSON.parse(JSON.stringify(row)) 
			if(this.isSingle){
				this.choiceCourse = [data]
			}else{
				var index = this.choiceCourse.map(item=>item.id).indexOf(data.id)
				if(index == -1){
					this.choiceCourse.push(data)
				}else{
					this.choiceCourse.splice(index,1)
				}				
			}
		},
		getData() {
		  var params = {
			endCreateTime: this.$refs.datetimeAdd
				?this.$refs.datetimeAdd.getTime.endTimeParse
				:'',
			endPlanEndTime: this.$refs.datetimeOpen
				?this.$refs.datetimeOpen.getTime.endTimeParse
				:'',
			pageIndex: this.currentPage,
			pageSize: this.pageSize,
			searchKey: this.selectVal.searchKey,
			searchValue: this.selectVal.searchVal,
			startCreateTime: this.$refs.datetimeAdd
				?this.$refs.datetimeAdd.getTime.startTimeParse
				:'',
			startPlanStartTime: this.$refs.datetimeOpen
				?this.$refs.datetimeOpen.getTime.startTimeParse
				:'',
			type: this.selfType!=-1?this.selfType:this.selectVal.type,
			userType: this.userType,
			offline: this.selectVal.offline
		  };
		  selectReq.courseOrgin(params).then(res => {
			if (res.Success) {
			  this.tableData = res.Data.dataList;
			  this.totalCount = res.Data.totalCount;
			//   this.choiceCourse = []
			} else {
			  this.$message.error(res.Msg);
			}
		  }).catch(res => {
			this.$message.error('课程源获取出错，请刷新重试！')
		  })
		},
		handleSizeChange(val) {
		  this.pageSize = val;
		  this.getData();
		},
		handleCurrentChange(val) {
		  this.currentPage = val;
		  this.getData();
		}
	},
	filters: {  
		typeFilter(value) {
			let text = ''
			switch(value){
				case 1: text = '直播'; break;
				case 2: text = '视频'; break;
				case 3: text = '线下'; break;
				case 4: text = '直播转视频'; break;
				case 5: text = '课件'; break;
				case 6: text = '网页'; break;
				case 8: text = '音频'; break;
				default: text = '其他'; break;
			}
			return text
		}
	}
};
</script>

<style type="text/less" lang="less" scoped>
.select-section {
  .el-dialog__wrapper {
	background-color: rgba(0, 0, 0, 0.1);
  }
  .pagination-wrap {
	margin-top: 10px;
  }
  .el-pagination {
	float: right;
  }
  .dialog-footer {
	margin-top: 40px;
  }
}
.search-row {
  margin-bottom: 10px;
  .input-with-select {
	width: 30%;
  }
  .search-select {
	width: 120px;
  }
}
.search-row>div{
	margin: 5px 5px 5px 0;
	max-width: 270px;
}
.virtualBox{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9;
}
</style>
<style type="text/css">
  .el-table .cell{
    position: relative;
  }
</style>


// WEBPACK FOOTER //
// src/components/selectSource/selectCourseOrgin.vue